module.exports = __webpack_public_path__ + "static/media/ear.85c3bf48.svg";